import { useState } from 'react';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <footer className="bg-base-200 border-t border-base-content/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="font-serif font-bold italic text-base-content text-sm tracking-tight whitespace-nowrap">
            La Marmotte Joyeuse
          </span>

          <button
            onClick={() => setContactOpen(prev => !prev)}
            className="flex items-center gap-1.5 text-xs text-base-content/60
                       hover:text-primary transition-colors"
          >
            <Mail size={11} />
            {t('footer.contact')}
            <span className={`transition-transform duration-200 inline-block
              ${contactOpen ? 'rotate-180' : ''}`}>
              ▾
            </span>
          </button>

          <div className="flex items-center gap-2">
            <a href="https://www.instagram.com/la_marmotte_joyeuse_05/"
               target="_blank" rel="noopener noreferrer"
               aria-label="Instagram"
               className="p-1 rounded-full hover:bg-base-content/10 transition-colors group">
              <Instagram size={14} className="text-base-content/60 group-hover:text-primary transition-colors" />
            </a>
          </div>
        </div>

        {contactOpen && (
          <div className="mt-3 pt-3 border-t border-base-content/10
                          flex flex-wrap gap-x-6 gap-y-2 text-xs text-base-content/60">
            <a href="tel:0663024248"
               className="flex items-center gap-1 hover:text-primary transition-colors">
              <Phone size={11} /> 06 63 02 42 48
            </a>
            <a href="mailto:lamarmottejoyeuse@gmail.com"
               className="flex items-center gap-1 hover:text-primary transition-colors">
              <Mail size={11} /> lamarmottejoyeuse@gmail.com
            </a>
            <span className="flex items-center gap-1">
              <MapPin size={11} /> 2 Imp. du Garde Champêtre, 05320 La Grave
            </span>
          </div>
        )}

        <div className="mt-3 pt-3 border-t border-base-content/10
                        flex flex-wrap items-center justify-between gap-2
                        text-xs text-base-content/40">
          <a href="/mentions-legales" className="hover:text-primary transition-colors">
            {t('footer.legal')}
          </a>
          <span>© {new Date().getFullYear()} La Marmotte Joyeuse. {t('footer.rights')}</span>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
